import { Component, inject, OnInit } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { EventsService } from '../../data-services/events.service';
import { TooltipModule } from 'primeng/tooltip';
import { Router, RouterModule } from '@angular/router';
import { EventBasic } from '../../data-services/models/events/event-basic.model';
import { Store } from '@ngrx/store';
import { selectAllEvents } from '../../data-services/stores/selectors/events.selectors';

@Component({
    selector: 'app-home',
    imports: [CarouselModule, TooltipModule, RouterModule],
    templateUrl: '../ui/home.component.html',
    styleUrl: '../ui/home.component.css'
})
export class HomeComponent implements OnInit {
  private readonly _eventService = inject(EventsService);
  private readonly _router = inject(Router);
  private readonly _store = inject(Store);
  eventList: EventBasic[] = [];

  ngOnInit(): void {
    this._store.select(selectAllEvents).subscribe(result => {
      this.eventList = result.filter(x => x.image).sort((a, b) => Math.random() < .5 ? -1 : 1); 
      if (this.eventList.length < 2) {
        this._router.navigate(["events"]);
      }
    })
  }
}
